import React, { useState } from "react";
import CodeEditor from "@uiw/react-textarea-code-editor";
import { Check } from "react-bootstrap-icons";

const Modal = ({ generatedCode }) => {
  const [copyStatus, setCopyStatus] = useState(false); // To indicate if the text was copied
  const handleOnClick = () => {
    setCopyStatus(true);
    navigator.clipboard.writeText(generatedCode);

    setTimeout(() => setCopyStatus(false), 1000); // Reset status after 2 seconds
  };
  return (
    <div>
      <dialog id="generator_result_modal" className="modal">
        <div className="modal-box w-11/12 max-w-5xl">
          <h3 className="font-bold text-lg">Your code is ready!</h3>
          <div className="modal-action justify-start">
            <form method="dialog">
              {/* if there is a button in form, it will close the modal 
              <button className="btn">Close</button>*/}
              <button className="btn btn-lg btn-circle btn-ghost absolute right-2 top-2">
                ✕
              </button>
            </form>{" "}
            <button
              style={{
                backgroundColor: copyStatus ? "lightgreen" : "",
              }}
              className="btn btn-md"
              onClick={handleOnClick}
            >
              {copyStatus ? "Copied! " : "Copy"}
            </button>
          </div>

          <div className="ps-2 py-4 space-y-4">
            <CodeEditor
              value={generatedCode}
              language="js"
              placeholder="Please enter JS code."
              //  onChange={(evn) => setCode(evn.target.value)}
              padding={15}
              style={{
                backgroundColor: "#f5f5f5",
                fontFamily:
                  "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                fontSize: "16px",
              }}
            />
            {/**         <button className="btn btn-md" onClick={handleOnClick}>
              {copyStatus ? <Check size={30} /> : "Copy"}
            </button>*/}
          </div>

          {/**         <div className="modal-action">
            <form method="dialog">
             
              <button className="btn">Close</button>
            </form>
          </div>*/}
        </div>
      </dialog>
    </div>
  );
};

export default Modal;
